














































import { Component, Vue, Watch } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys';
import AppDto from '@/models/Apps/AppDto';
import UpdateAppRequest from '@/models/Apps/UpdateAppRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AppEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new AppDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(SysModule.currentApp));
    }
  }

  get loading() {
    return SysModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAppRequest();
    request.updatedAt = this.entity.updatedAt;
    request.minimumVersion = this.entity.minimumVersion;
    await SysModule.editApp(request)
    this.dialog = false;
  }
}
